import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";

const CaseStudiesHeading = () => {
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "2rem",
        display: "flex",
        flexDirection: { xs: "column-reverse", sm: "row" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "100%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "0rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)", // Add your desired color here
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.8rem",
          }}
        >
          HOW WE HAVE HELPED OUR CLIENTS
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
          }}
        >
          Case <span style={{ color: "rgba(255, 102, 0, 1)" }}>Studies</span>
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
          }}
        >
          Real impact, real results. Our case studies showcase how we’ve helped
          businesses cut through complexity, harness data-driven insights, and
          unlock transformative growth with clarity and confidence. From
          crafting market entry strategies to accurately forecasting growth for
          our client brands, each success story is a testament to our tailored,
          strategic and consultative approach. Explore how we turn challenges
          into opportunities, driving measurable outcomes that matter.
        </Typography>
      </Box>
    </Box>
  );
};

export default CaseStudiesHeading;
